import { NewUITranslation, UITranslation } from '@go-shared/types/uitranslation';
import { apiPost, apiGet } from '.';

export async function getUITranslations(propertyId: string): Promise<UITranslation[]> {
  return apiGet(`/property/${propertyId}/uitranslation`);
}

export async function replaceUITranslationByNamespace(
  propertyId: string,
  namespace: string,
  translation: NewUITranslation
): Promise<UITranslation> {
  return apiPost(`/property/${propertyId}/uitranslation-namespace/${namespace}`, translation);
}
